// source: accounts/protos/user.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var accounts_protos_user_dto_pb = require('../../accounts/protos/user_dto_pb.js');
goog.object.extend(proto, accounts_protos_user_dto_pb);
var accounts_protos_session_pb = require('../../accounts/protos/session_pb.js');
goog.object.extend(proto, accounts_protos_session_pb);
goog.exportSymbol('proto.accounts.protos.CreateUserRequest', null, global);
goog.exportSymbol('proto.accounts.protos.CreateUserResponse', null, global);
goog.exportSymbol('proto.accounts.protos.DeleteUserRequest', null, global);
goog.exportSymbol('proto.accounts.protos.DeleteUserResponse', null, global);
goog.exportSymbol('proto.accounts.protos.PatchUserRequest', null, global);
goog.exportSymbol('proto.accounts.protos.PatchUserResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.CreateUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.CreateUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.CreateUserRequest.displayName = 'proto.accounts.protos.CreateUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.CreateUserResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.CreateUserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.CreateUserResponse.displayName = 'proto.accounts.protos.CreateUserResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.PatchUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.PatchUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.PatchUserRequest.displayName = 'proto.accounts.protos.PatchUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.PatchUserResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.PatchUserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.PatchUserResponse.displayName = 'proto.accounts.protos.PatchUserResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.DeleteUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.DeleteUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.DeleteUserRequest.displayName = 'proto.accounts.protos.DeleteUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.DeleteUserResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.DeleteUserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.DeleteUserResponse.displayName = 'proto.accounts.protos.DeleteUserResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.CreateUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.CreateUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.CreateUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.CreateUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    password: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    confirmPassword: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    country: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    mobileNumber: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    mobileNumberPrefix: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
    preferredLanguage: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.CreateUserRequest}
 */
proto.accounts.protos.CreateUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.CreateUserRequest;
  return proto.accounts.protos.CreateUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.CreateUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.CreateUserRequest}
 */
proto.accounts.protos.CreateUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfirmPassword(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobileNumber(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobileNumberPrefix(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreferredLanguage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.CreateUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.CreateUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.CreateUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.CreateUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.accounts.protos.CreateUserRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.CreateUserRequest} returns this
 */
proto.accounts.protos.CreateUserRequest.prototype.setEmail = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.CreateUserRequest} returns this
 */
proto.accounts.protos.CreateUserRequest.prototype.clearEmail = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateUserRequest.prototype.hasEmail = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string password = 4;
 * @return {string}
 */
proto.accounts.protos.CreateUserRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.CreateUserRequest} returns this
 */
proto.accounts.protos.CreateUserRequest.prototype.setPassword = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.CreateUserRequest} returns this
 */
proto.accounts.protos.CreateUserRequest.prototype.clearPassword = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateUserRequest.prototype.hasPassword = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string confirm_password = 5;
 * @return {string}
 */
proto.accounts.protos.CreateUserRequest.prototype.getConfirmPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.CreateUserRequest} returns this
 */
proto.accounts.protos.CreateUserRequest.prototype.setConfirmPassword = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.CreateUserRequest} returns this
 */
proto.accounts.protos.CreateUserRequest.prototype.clearConfirmPassword = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateUserRequest.prototype.hasConfirmPassword = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string country = 6;
 * @return {string}
 */
proto.accounts.protos.CreateUserRequest.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.CreateUserRequest} returns this
 */
proto.accounts.protos.CreateUserRequest.prototype.setCountry = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.CreateUserRequest} returns this
 */
proto.accounts.protos.CreateUserRequest.prototype.clearCountry = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateUserRequest.prototype.hasCountry = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string mobile_number = 7;
 * @return {string}
 */
proto.accounts.protos.CreateUserRequest.prototype.getMobileNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.CreateUserRequest} returns this
 */
proto.accounts.protos.CreateUserRequest.prototype.setMobileNumber = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.CreateUserRequest} returns this
 */
proto.accounts.protos.CreateUserRequest.prototype.clearMobileNumber = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateUserRequest.prototype.hasMobileNumber = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string mobile_number_prefix = 8;
 * @return {string}
 */
proto.accounts.protos.CreateUserRequest.prototype.getMobileNumberPrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.CreateUserRequest} returns this
 */
proto.accounts.protos.CreateUserRequest.prototype.setMobileNumberPrefix = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.CreateUserRequest} returns this
 */
proto.accounts.protos.CreateUserRequest.prototype.clearMobileNumberPrefix = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateUserRequest.prototype.hasMobileNumberPrefix = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string preferred_language = 9;
 * @return {string}
 */
proto.accounts.protos.CreateUserRequest.prototype.getPreferredLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.CreateUserRequest} returns this
 */
proto.accounts.protos.CreateUserRequest.prototype.setPreferredLanguage = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.CreateUserRequest} returns this
 */
proto.accounts.protos.CreateUserRequest.prototype.clearPreferredLanguage = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateUserRequest.prototype.hasPreferredLanguage = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.CreateUserResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.CreateUserResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.CreateUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.CreateUserResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    statusCode: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    session: (f = msg.getSession()) && accounts_protos_session_pb.SessionResponse.toObject(includeInstance, f),
    emailError: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    passwordError: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    confirmPasswordError: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    countryError: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    mobileNumberPrefixError: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    mobileNumberError: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
    preferredLanguageError: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.CreateUserResponse}
 */
proto.accounts.protos.CreateUserResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.CreateUserResponse;
  return proto.accounts.protos.CreateUserResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.CreateUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.CreateUserResponse}
 */
proto.accounts.protos.CreateUserResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatusCode(value);
      break;
    case 2:
      var value = new accounts_protos_session_pb.SessionResponse;
      reader.readMessage(value,accounts_protos_session_pb.SessionResponse.deserializeBinaryFromReader);
      msg.setSession(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailError(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPasswordError(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfirmPasswordError(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryError(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobileNumberPrefixError(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobileNumberError(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreferredLanguageError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.CreateUserResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.CreateUserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.CreateUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.CreateUserResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getSession();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      accounts_protos_session_pb.SessionResponse.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * required uint32 status_code = 1;
 * @return {number}
 */
proto.accounts.protos.CreateUserResponse.prototype.getStatusCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
 */
proto.accounts.protos.CreateUserResponse.prototype.setStatusCode = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
 */
proto.accounts.protos.CreateUserResponse.prototype.clearStatusCode = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateUserResponse.prototype.hasStatusCode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SessionResponse session = 2;
 * @return {?proto.accounts.protos.SessionResponse}
 */
proto.accounts.protos.CreateUserResponse.prototype.getSession = function() {
  return /** @type{?proto.accounts.protos.SessionResponse} */ (
    jspb.Message.getWrapperField(this, accounts_protos_session_pb.SessionResponse, 2));
};


/**
 * @param {?proto.accounts.protos.SessionResponse|undefined} value
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
*/
proto.accounts.protos.CreateUserResponse.prototype.setSession = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
 */
proto.accounts.protos.CreateUserResponse.prototype.clearSession = function() {
  return this.setSession(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateUserResponse.prototype.hasSession = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string email_error = 3;
 * @return {string}
 */
proto.accounts.protos.CreateUserResponse.prototype.getEmailError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
 */
proto.accounts.protos.CreateUserResponse.prototype.setEmailError = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
 */
proto.accounts.protos.CreateUserResponse.prototype.clearEmailError = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateUserResponse.prototype.hasEmailError = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string password_error = 4;
 * @return {string}
 */
proto.accounts.protos.CreateUserResponse.prototype.getPasswordError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
 */
proto.accounts.protos.CreateUserResponse.prototype.setPasswordError = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
 */
proto.accounts.protos.CreateUserResponse.prototype.clearPasswordError = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateUserResponse.prototype.hasPasswordError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string confirm_password_error = 5;
 * @return {string}
 */
proto.accounts.protos.CreateUserResponse.prototype.getConfirmPasswordError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
 */
proto.accounts.protos.CreateUserResponse.prototype.setConfirmPasswordError = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
 */
proto.accounts.protos.CreateUserResponse.prototype.clearConfirmPasswordError = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateUserResponse.prototype.hasConfirmPasswordError = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string country_error = 6;
 * @return {string}
 */
proto.accounts.protos.CreateUserResponse.prototype.getCountryError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
 */
proto.accounts.protos.CreateUserResponse.prototype.setCountryError = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
 */
proto.accounts.protos.CreateUserResponse.prototype.clearCountryError = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateUserResponse.prototype.hasCountryError = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string mobile_number_prefix_error = 7;
 * @return {string}
 */
proto.accounts.protos.CreateUserResponse.prototype.getMobileNumberPrefixError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
 */
proto.accounts.protos.CreateUserResponse.prototype.setMobileNumberPrefixError = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
 */
proto.accounts.protos.CreateUserResponse.prototype.clearMobileNumberPrefixError = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateUserResponse.prototype.hasMobileNumberPrefixError = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string mobile_number_error = 8;
 * @return {string}
 */
proto.accounts.protos.CreateUserResponse.prototype.getMobileNumberError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
 */
proto.accounts.protos.CreateUserResponse.prototype.setMobileNumberError = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
 */
proto.accounts.protos.CreateUserResponse.prototype.clearMobileNumberError = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateUserResponse.prototype.hasMobileNumberError = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string preferred_language_error = 9;
 * @return {string}
 */
proto.accounts.protos.CreateUserResponse.prototype.getPreferredLanguageError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
 */
proto.accounts.protos.CreateUserResponse.prototype.setPreferredLanguageError = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.CreateUserResponse} returns this
 */
proto.accounts.protos.CreateUserResponse.prototype.clearPreferredLanguageError = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.CreateUserResponse.prototype.hasPreferredLanguageError = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.PatchUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.PatchUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.PatchUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.PatchUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    country: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    mobileNumber: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    mobileNumberPrefix: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    avatarCode: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    introCompleted: (f = jspb.Message.getBooleanField(msg, 8)) == null ? undefined : f,
    pushNotifications: (f = jspb.Message.getBooleanField(msg, 9)) == null ? undefined : f,
    oldPassword: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
    password: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f,
    confirmPassword: (f = jspb.Message.getField(msg, 12)) == null ? undefined : f,
    preferredLanguage: (f = jspb.Message.getField(msg, 13)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.PatchUserRequest}
 */
proto.accounts.protos.PatchUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.PatchUserRequest;
  return proto.accounts.protos.PatchUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.PatchUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.PatchUserRequest}
 */
proto.accounts.protos.PatchUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobileNumber(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobileNumberPrefix(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAvatarCode(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIntroCompleted(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPushNotifications(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setOldPassword(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfirmPassword(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreferredLanguage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.PatchUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.PatchUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.PatchUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.PatchUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeBool(
      8,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeBool(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeString(
      12,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.accounts.protos.PatchUserRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.setEmail = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.clearEmail = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserRequest.prototype.hasEmail = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string country = 4;
 * @return {string}
 */
proto.accounts.protos.PatchUserRequest.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.setCountry = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.clearCountry = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserRequest.prototype.hasCountry = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string mobile_number = 5;
 * @return {string}
 */
proto.accounts.protos.PatchUserRequest.prototype.getMobileNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.setMobileNumber = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.clearMobileNumber = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserRequest.prototype.hasMobileNumber = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string mobile_number_prefix = 6;
 * @return {string}
 */
proto.accounts.protos.PatchUserRequest.prototype.getMobileNumberPrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.setMobileNumberPrefix = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.clearMobileNumberPrefix = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserRequest.prototype.hasMobileNumberPrefix = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int32 avatar_code = 7;
 * @return {number}
 */
proto.accounts.protos.PatchUserRequest.prototype.getAvatarCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.setAvatarCode = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.clearAvatarCode = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserRequest.prototype.hasAvatarCode = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool intro_completed = 8;
 * @return {boolean}
 */
proto.accounts.protos.PatchUserRequest.prototype.getIntroCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.setIntroCompleted = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.clearIntroCompleted = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserRequest.prototype.hasIntroCompleted = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool push_notifications = 9;
 * @return {boolean}
 */
proto.accounts.protos.PatchUserRequest.prototype.getPushNotifications = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.setPushNotifications = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.clearPushNotifications = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserRequest.prototype.hasPushNotifications = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string old_password = 10;
 * @return {string}
 */
proto.accounts.protos.PatchUserRequest.prototype.getOldPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.setOldPassword = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.clearOldPassword = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserRequest.prototype.hasOldPassword = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string password = 11;
 * @return {string}
 */
proto.accounts.protos.PatchUserRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.setPassword = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.clearPassword = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserRequest.prototype.hasPassword = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string confirm_password = 12;
 * @return {string}
 */
proto.accounts.protos.PatchUserRequest.prototype.getConfirmPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.setConfirmPassword = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.clearConfirmPassword = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserRequest.prototype.hasConfirmPassword = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string preferred_language = 13;
 * @return {string}
 */
proto.accounts.protos.PatchUserRequest.prototype.getPreferredLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.setPreferredLanguage = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserRequest} returns this
 */
proto.accounts.protos.PatchUserRequest.prototype.clearPreferredLanguage = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserRequest.prototype.hasPreferredLanguage = function() {
  return jspb.Message.getField(this, 13) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.PatchUserResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.PatchUserResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.PatchUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.PatchUserResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    statusCode: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    user: (f = msg.getUser()) && accounts_protos_user_dto_pb.UserDTO.toObject(includeInstance, f),
    emailError: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    countryError: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    mobileNumberError: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    mobileNumberPrefixError: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    avatarCodeError: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    introCompletedError: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
    pushNotificationsError: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
    oldPasswordError: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
    passwordError: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f,
    confirmPasswordError: (f = jspb.Message.getField(msg, 12)) == null ? undefined : f,
    preferredLanguageError: (f = jspb.Message.getField(msg, 13)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.PatchUserResponse}
 */
proto.accounts.protos.PatchUserResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.PatchUserResponse;
  return proto.accounts.protos.PatchUserResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.PatchUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.PatchUserResponse}
 */
proto.accounts.protos.PatchUserResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatusCode(value);
      break;
    case 2:
      var value = new accounts_protos_user_dto_pb.UserDTO;
      reader.readMessage(value,accounts_protos_user_dto_pb.UserDTO.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailError(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryError(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobileNumberError(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobileNumberPrefixError(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatarCodeError(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setIntroCompletedError(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPushNotificationsError(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setOldPasswordError(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPasswordError(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfirmPasswordError(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreferredLanguageError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.PatchUserResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.PatchUserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.PatchUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.PatchUserResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      accounts_protos_user_dto_pb.UserDTO.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeString(
      12,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * required uint32 status_code = 1;
 * @return {number}
 */
proto.accounts.protos.PatchUserResponse.prototype.getStatusCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.setStatusCode = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.clearStatusCode = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserResponse.prototype.hasStatusCode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UserDTO user = 2;
 * @return {?proto.accounts.protos.UserDTO}
 */
proto.accounts.protos.PatchUserResponse.prototype.getUser = function() {
  return /** @type{?proto.accounts.protos.UserDTO} */ (
    jspb.Message.getWrapperField(this, accounts_protos_user_dto_pb.UserDTO, 2));
};


/**
 * @param {?proto.accounts.protos.UserDTO|undefined} value
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
*/
proto.accounts.protos.PatchUserResponse.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserResponse.prototype.hasUser = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string email_error = 3;
 * @return {string}
 */
proto.accounts.protos.PatchUserResponse.prototype.getEmailError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.setEmailError = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.clearEmailError = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserResponse.prototype.hasEmailError = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string country_error = 4;
 * @return {string}
 */
proto.accounts.protos.PatchUserResponse.prototype.getCountryError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.setCountryError = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.clearCountryError = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserResponse.prototype.hasCountryError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string mobile_number_error = 5;
 * @return {string}
 */
proto.accounts.protos.PatchUserResponse.prototype.getMobileNumberError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.setMobileNumberError = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.clearMobileNumberError = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserResponse.prototype.hasMobileNumberError = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string mobile_number_prefix_error = 6;
 * @return {string}
 */
proto.accounts.protos.PatchUserResponse.prototype.getMobileNumberPrefixError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.setMobileNumberPrefixError = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.clearMobileNumberPrefixError = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserResponse.prototype.hasMobileNumberPrefixError = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string avatar_code_error = 7;
 * @return {string}
 */
proto.accounts.protos.PatchUserResponse.prototype.getAvatarCodeError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.setAvatarCodeError = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.clearAvatarCodeError = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserResponse.prototype.hasAvatarCodeError = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string intro_completed_error = 8;
 * @return {string}
 */
proto.accounts.protos.PatchUserResponse.prototype.getIntroCompletedError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.setIntroCompletedError = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.clearIntroCompletedError = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserResponse.prototype.hasIntroCompletedError = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string push_notifications_error = 9;
 * @return {string}
 */
proto.accounts.protos.PatchUserResponse.prototype.getPushNotificationsError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.setPushNotificationsError = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.clearPushNotificationsError = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserResponse.prototype.hasPushNotificationsError = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string old_password_error = 10;
 * @return {string}
 */
proto.accounts.protos.PatchUserResponse.prototype.getOldPasswordError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.setOldPasswordError = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.clearOldPasswordError = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserResponse.prototype.hasOldPasswordError = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string password_error = 11;
 * @return {string}
 */
proto.accounts.protos.PatchUserResponse.prototype.getPasswordError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.setPasswordError = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.clearPasswordError = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserResponse.prototype.hasPasswordError = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string confirm_password_error = 12;
 * @return {string}
 */
proto.accounts.protos.PatchUserResponse.prototype.getConfirmPasswordError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.setConfirmPasswordError = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.clearConfirmPasswordError = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserResponse.prototype.hasConfirmPasswordError = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string preferred_language_error = 13;
 * @return {string}
 */
proto.accounts.protos.PatchUserResponse.prototype.getPreferredLanguageError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.setPreferredLanguageError = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PatchUserResponse} returns this
 */
proto.accounts.protos.PatchUserResponse.prototype.clearPreferredLanguageError = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PatchUserResponse.prototype.hasPreferredLanguageError = function() {
  return jspb.Message.getField(this, 13) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.DeleteUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.DeleteUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.DeleteUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.DeleteUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    password: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.DeleteUserRequest}
 */
proto.accounts.protos.DeleteUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.DeleteUserRequest;
  return proto.accounts.protos.DeleteUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.DeleteUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.DeleteUserRequest}
 */
proto.accounts.protos.DeleteUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.DeleteUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.DeleteUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.DeleteUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.DeleteUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string password = 1;
 * @return {string}
 */
proto.accounts.protos.DeleteUserRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.DeleteUserRequest} returns this
 */
proto.accounts.protos.DeleteUserRequest.prototype.setPassword = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.DeleteUserRequest} returns this
 */
proto.accounts.protos.DeleteUserRequest.prototype.clearPassword = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.DeleteUserRequest.prototype.hasPassword = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.DeleteUserResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.DeleteUserResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.DeleteUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.DeleteUserResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    statusCode: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    session: (f = msg.getSession()) && accounts_protos_session_pb.SessionResponse.toObject(includeInstance, f),
    passwordError: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.DeleteUserResponse}
 */
proto.accounts.protos.DeleteUserResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.DeleteUserResponse;
  return proto.accounts.protos.DeleteUserResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.DeleteUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.DeleteUserResponse}
 */
proto.accounts.protos.DeleteUserResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatusCode(value);
      break;
    case 2:
      var value = new accounts_protos_session_pb.SessionResponse;
      reader.readMessage(value,accounts_protos_session_pb.SessionResponse.deserializeBinaryFromReader);
      msg.setSession(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPasswordError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.DeleteUserResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.DeleteUserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.DeleteUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.DeleteUserResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getSession();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      accounts_protos_session_pb.SessionResponse.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * required uint32 status_code = 1;
 * @return {number}
 */
proto.accounts.protos.DeleteUserResponse.prototype.getStatusCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accounts.protos.DeleteUserResponse} returns this
 */
proto.accounts.protos.DeleteUserResponse.prototype.setStatusCode = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.DeleteUserResponse} returns this
 */
proto.accounts.protos.DeleteUserResponse.prototype.clearStatusCode = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.DeleteUserResponse.prototype.hasStatusCode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SessionResponse session = 2;
 * @return {?proto.accounts.protos.SessionResponse}
 */
proto.accounts.protos.DeleteUserResponse.prototype.getSession = function() {
  return /** @type{?proto.accounts.protos.SessionResponse} */ (
    jspb.Message.getWrapperField(this, accounts_protos_session_pb.SessionResponse, 2));
};


/**
 * @param {?proto.accounts.protos.SessionResponse|undefined} value
 * @return {!proto.accounts.protos.DeleteUserResponse} returns this
*/
proto.accounts.protos.DeleteUserResponse.prototype.setSession = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.DeleteUserResponse} returns this
 */
proto.accounts.protos.DeleteUserResponse.prototype.clearSession = function() {
  return this.setSession(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.DeleteUserResponse.prototype.hasSession = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string password_error = 3;
 * @return {string}
 */
proto.accounts.protos.DeleteUserResponse.prototype.getPasswordError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.DeleteUserResponse} returns this
 */
proto.accounts.protos.DeleteUserResponse.prototype.setPasswordError = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.DeleteUserResponse} returns this
 */
proto.accounts.protos.DeleteUserResponse.prototype.clearPasswordError = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.DeleteUserResponse.prototype.hasPasswordError = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.accounts.protos);
